import { ROUTES } from '../constants';

const accountDetailsRouteMatcher = new RegExp(
  `${ROUTES.ACCOUNTS}/(.*)/account-details`
);

const getAccountNumberFromPath = (pathname) => {
  if (!pathname.startsWith(ROUTES.ACCOUNTS)) {
    return null;
  }
  if (pathname.startsWith(ROUTES.ACCOUNT_MANAGEMENT)) {
    return null;
  }
  if (pathname.startsWith(ROUTES.OPEN_NEW_ACCOUNT)) {
    return null;
  }
  if (accountDetailsRouteMatcher.test(pathname)) {
    return null;
  }
  return pathname.slice(ROUTES.ACCOUNTS.length + 1);
};

export default getAccountNumberFromPath;
